import { render } from "./PwdDeclined.vue?vue&type=template&id=5045828f"
import script from "./PwdDeclined.vue?vue&type=script&lang=js"
export * from "./PwdDeclined.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__